export default class QuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.value = 1;
        this.min = 1;
        this.max = Infinity;
    }

    connectedCallback() {
        this.decreaseBtn = this.querySelector('button:first-of-type');
        this.increaseBtn = this.querySelector('button:last-of-type');
        this.input = this.querySelector('input[type="number"]');
        this.href = this.getAttribute('data-href');
        this.sendCart = document.getElementById('add-recipe');
        this.showMore = document.getElementById('show-more-recipe');

        this.value = parseInt(this.input.value) || this.min;
        this.min = parseInt(this.input.min) || this.min;
        this.max = parseInt(this.input.max) || this.max;

        this.decreaseBtn.addEventListener('click', () => this.decrease());
        this.increaseBtn.addEventListener('click', () => this.increase());
        this.input.addEventListener('change', () => this.updateValue());

        //Propre a la partie recettes
        if(this.sendCart) {
            this.sendCart.addEventListener('click', () => this.addToCart());
        }

        if(this.showMore) {
            this.showMore.addEventListener('click', (e) => {
                e.preventDefault();
                this.showMore.style.display = 'none';
                document.querySelector('.ingredients-container').classList.remove('ingredients-container');
            });
        }

        this.updateButtonStates();
    }

    addToCart() {
        const href = this.sendCart.getAttribute('data-href');
        var datas = {
            servings: this.value,
        };

        HegydCore.sendRequest(href, 'POST', datas, function (data) {
            window.toastr.success(data.message);
        });
    }

    decrease() {
        if (this.value > this.min) {
            this.value--;
            this.updateInput();
        }
    }

    increase() {
        if (this.value < this.max) {
            this.value++;
            this.updateInput();
        }
    }

    updateValue() {
        const newValue = parseInt(this.input.value);
        if (!isNaN(newValue) && newValue >= this.min && newValue <= this.max) {
            this.value = newValue;
        } else {
            this.input.value = this.value;
        }
        this.updateButtonStates();

        //On met à jour la liste des produits
        this.updateView(this.value);
    }

    updateInput() {
        this.input.value = this.value;
        this.updateButtonStates();
        this.input.dispatchEvent(new CustomEvent('change', { detail: this.value }));

        //On met à jour la liste des produits
        this.updateView(this.value);
    }

    updateButtonStates() {
        this.decreaseBtn.disabled = this.value <= this.min;
        this.increaseBtn.disabled = this.value >= this.max;
    }

    updateView(value) {
        if(this.sendCart) {
            var datas = {
                servings: value,
            };

            HegydCore.sendRequest(this.href, 'GET', datas, function (data) {
                document.getElementById('recipe_products_list').innerHTML = data;
            });
        }
    }
}
